import React from 'react';
import { BookmarkIcon } from '@heroicons/react/24/outline';
import type { ChatSource } from '@archie/api-shared';

interface SourcesBadgeProps {
  sources: ChatSource[];
  onClick: () => void;
}

const breakdown = (sources: ChatSource[]): string => {
  let kb = 0;
  let web = 0;
  for (const s of sources) {
    if (s.kind === 'kb') kb++;
    else web++;
  }
  const parts: string[] = [];
  if (kb > 0) parts.push(`${kb} document${kb === 1 ? '' : 's'}`);
  if (web > 0) parts.push(`${web} web ${web === 1 ? 'page' : 'pages'}`);
  return parts.join(' · ') || 'No sources';
};

const SourcesBadge: React.FC<SourcesBadgeProps> = ({ sources, onClick }) => {
  if (sources.length === 0) return null;
  const tooltip = breakdown(sources);
  return (
    <button
      type="button"
      onClick={onClick}
      className="ml-3 inline-flex items-center gap-1 rounded-full border border-(--color-border-default) px-2 py-0.5 text-xs text-(--color-text-muted) hover:text-(--color-text-secondary) hover:bg-(--color-surface-subtle) transition-colors"
      title={tooltip}
      aria-label={`Sources: ${tooltip}`}
    >
      <BookmarkIcon className="h-3.5 w-3.5" />
      <span>{sources.length}</span>
    </button>
  );
};

export default SourcesBadge;
